// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../../Config.bs.js";
import * as CrmNetwork from "../../../../../../../library/network/CrmNetwork.bs.js";
import * as NetworkUtils from "../../../../../../../library/NetworkUtils.bs.js";
import * as CountryConfig from "../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as LoadAssistInfoRepoConfig from "./LoadAssistInfoRepoConfig.bs.js";

function fetchLoadAssistInfo(order_crn, country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + ("/api/v1/load-assist/orders/details?order_crns=" + order_crn);
  return NetworkUtils.catchPromiseError(CrmNetwork.get(requestUrl, undefined, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(LoadAssistInfoRepoConfig.LoadAssistInfoResponseConverter.execute, result);
                            });
                }), requestUrl);
}

var LoadAssistInfoRepo = {
  fetchLoadAssistInfo: fetchLoadAssistInfo
};

export {
  LoadAssistInfoRepo ,
  
}
/* Config Not a pure module */
